import { SVGProps } from 'react';

export function InstagramIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <g clipPath="url(#clip0_4839_9744)">
        <path
          d="M2.0001 2.17732C-0.514564 4.78932 0.00010293 7.56399 0.00010293 15.9933C0.00010293 22.9933 -1.22123 30.0107 5.17077 31.6627C7.16677 32.176 24.8521 32.176 26.8454 31.66C29.5068 30.9733 31.6721 28.8147 31.9681 25.0507C32.0094 24.5253 32.0094 7.47066 31.9668 6.93466C31.6521 2.92532 29.1841 0.614657 25.9321 0.146657C25.1868 0.0386573 25.0374 0.00665732 21.2134 -9.34675e-06C7.64944 0.00665732 4.6761 -0.597343 2.0001 2.17732Z"
          fill="url(#paint0_linear_4839_9744)"
        />
        <path
          d="M15.9972 4.18532C11.1559 4.18532 6.55858 3.75466 4.80258 8.26132C4.07725 10.1227 4.18258 12.54 4.18258 16.0013C4.18258 19.0387 4.08525 21.8933 4.80258 23.74C6.55458 28.2493 11.1892 27.8173 15.9946 27.8173C20.6306 27.8173 25.4106 28.3 27.1879 23.74C27.9146 21.86 27.8079 19.4787 27.8079 16.0013C27.8079 11.3853 28.0626 8.40532 25.8239 6.16799C23.5572 3.90132 20.4919 4.18532 15.9919 4.18532H15.9972ZM14.9386 6.31466C25.0372 6.29866 26.3226 5.17599 25.6132 20.772C25.3612 26.288 21.1612 25.6827 15.9986 25.6827C6.58525 25.6827 6.31458 25.4133 6.31458 15.996C6.31458 6.46932 7.06125 6.31999 14.9386 6.31199V6.31466ZM22.3039 8.27599C21.5212 8.27599 20.8866 8.91066 20.8866 9.69332C20.8866 10.476 21.5212 11.1107 22.3039 11.1107C23.0866 11.1107 23.7212 10.476 23.7212 9.69332C23.7212 8.91066 23.0866 8.27599 22.3039 8.27599ZM15.9972 9.93332C12.6466 9.93332 9.93058 12.6507 9.93058 16.0013C9.93058 19.352 12.6466 22.068 15.9972 22.068C19.3479 22.068 22.0626 19.352 22.0626 16.0013C22.0626 12.6507 19.3479 9.93332 15.9972 9.93332ZM15.9972 12.0627C21.2039 12.0627 21.2106 19.94 15.9972 19.94C10.7919 19.94 10.7839 12.0627 15.9972 12.0627Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4839_9744"
          x1="2.06146"
          y1="29.9561"
          x2="31.8021"
          y2="4.21595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </linearGradient>
        <clipPath id="clip0_4839_9744">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
